/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type {
  GroundingCommandBarActionsState,
  GroundingCommandBarActionsSlots,
} from './GroundingCommandBarActions.types';

/**
 * Render the final JSX of GroundingCommandBarActions
 */
export const renderGroundingCommandBarActions_unstable = (state: GroundingCommandBarActionsState): JSXElement => {
  assertSlots<GroundingCommandBarActionsSlots>(state);

  // TODO Add additional slots in the appropriate place
  return <state.root />;
};
